import { pipe } from 'remeda';
import {
  whitespaceRegex,
  ampersandLiteral,
  lessThanLiteral,
  greaterThanLiteral,
  // singleQuoteLiteral,
  doubleQuoteLiteral,
} from '../regexes/regexes';

const stripExtraWhitespace = (str: string): string => {
  return str.replace(whitespaceRegex, ' ').trim();
};

const escapeHTML = (input: string = ''): string => {
  return input
    .replace(ampersandLiteral, '&amp;')
    .replace(lessThanLiteral, '&lt;')
    .replace(greaterThanLiteral, '&gt;')
    .replace(doubleQuoteLiteral, '&quot;');
  // .replace(singleQuoteLiteral, '&#39;'); // apostrophes are common in names and messages, and don't pose a risk for XSS in this context, so we can choose not to escape them to allow for more natural input. If we find that we do need to escape them later, we can easily add this back in.
};

const normaliseNameInput = (val: string) =>
  val
    .replace(/[\u2018\u2019]/g, "'")   // smart apostrophes → ASCII apostrophe
    .replace(/[\u2010\u2011\u2013\u2014]/g, '-'); // unicode hyphens/dashes → ASCII

const sanitizeString = (str: string = ''): string => {
  return stripExtraWhitespace(str);
};

const normalizationForm = 'NFKC' as const;
const normalizeString = (str: string = '') =>
  str.normalize(normalizationForm).trim();

const normalizeEmail = (email: string = '') => email.trim().toLowerCase();

const normalizeAndSanitizeString = (input: string = '') =>
  pipe(input, normaliseNameInput, normalizeString, sanitizeString);

const capitaliseFirstLetter = (str: string = ''): string => {
  if (str.length === 0) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export {
  capitaliseFirstLetter,
  stripExtraWhitespace,
  escapeHTML,
  sanitizeString,
  normalizeString,
  normalizeAndSanitizeString,
  normalizationForm,
  normalizeEmail,
  normaliseNameInput,
};
